import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { StructExam } from "../model/exam/exam";
import { Candidate, Exam } from "../model/exam/result";
import * as echarts from "echarts";
import V from "@/store/vuex-store";

export class CandidateSubmitFinish extends Model {
  count = 0;
  list: Candidate[] = [new Candidate()];
}
//首页 顶部信息
export class DashTopData extends Model {
  candidateSubmitFinish = new CandidateSubmitFinish(); //今日面试完成
  candidateNoAudit = new CandidateSubmitFinish(); //全部 待评估人数
  examCommonlyUsedList: StructExam[] = [new StructExam()]; //常用面试

  static get(companyId: number) {
    return request
      .post("aiExam/dashboard/overview", { companyId, examType: V.getExamType })
      .then(res => {
        return new DashTopData().assign(res.data.data);
      });
  }
}

export class T extends Model {
  create = 0; //新增
  login = 0; //填写
  submitFinish = 0; //完成
  auditPass = 0; //通过
}
export class D extends Model {
  headers: string[] = [""];
  rowCreate: number[] = [0];
  rowLogin: number[] = [0];
  rowSubmitFinish: number[] = [0];
  rowAuditPass: number[] = [0];
}
//人数监控
export class PeopleData extends Model {
  count = new T(); //
  detail = new D();

  static get(companyId: number, examId: number, daysLimit: number) {
    return request
      .post("aiExam/dashboard/monitor", {
        companyId,
        examId,
        daysLimit,
        examType: V.getExamType
      })
      .then(res => {
        return new PeopleData().assign(res.data.data);
      });
  }
}

export class B extends Model {
  headers: string[] = [""];
  row: number[] = [0];
}
//考试开始时间 时长
export class TimeData extends Model {
  byBeginTime = new B(); //
  byTimeDuration = new B();

  static get(companyId: number) {
    return request
      .post("aiExam/dashboard/analyse", { companyId, examType: V.getExamType })
      .then(res => {
        return new TimeData().assign(res.data.data);
      });
  }
}

//所有面试
export class AllExam extends Model {
  count = 0; //
  list: Exam[] = [new Exam()];

  static get(companyId: number) {
    return request
      .post("aiExam/company/examAll", { companyId, examType: V.getExamType })
      .then(res => {
        return new AllExam().assign(res.data.data);
      });
  }
}

//添加常用面试
export class AddAlways extends Model {
  static set(params: any) {
    params = { ...params, examType: V.getExamType };
    return request
      .post("aiExam/company/examMarkCommonlyUsed", params)
      .then(res => {
        return res;
      });
  }
}

const ecOptionLD = {
  color: [
    "#525fff",
    "rgba(59, 205, 187, 1)",
    "#3AC4FFFF",
    "rgba(255, 140, 15, 1)"
  ],

  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985"
      }
    }
  },
  legend: {
    itemGap: 24,
    icon: "circle",
    itemHeight: 8,
    itemWidth: 8,
    top: "5%",
    data: ["新增候选人数", "填写信息人数", "完成面试人数", "通过人数"],
    selected: {
      新增候选人数: true,
      填写信息人数: true,
      完成面试人数: true,
      通过人数: true
    } // 不需要显示的设置为false
  },

  grid: {
    left: "3%",
    right: "3%",
    bottom: "3%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      axisTick: {
        inside: true, //刻度
        lineStyle: {
          color: "#DEEAFF"
        }
      }
    }
  ],
  yAxis: [
    {
      type: "value"
    }
  ],
  series: [
    {
      name: "新增候选人数",
      type: "line",
      stack: "Total",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(82, 95, 255, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(82, 95, 255, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [98, 92, 120, 80, 111, 102, 91]
    },
    {
      name: "填写信息人数",
      type: "line",
      stack: "Total2",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(59, 205, 187, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(59, 205, 187, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [51, 53, 59, 50, 52, 54, 58]
    },
    {
      name: "完成面试人数",
      type: "line",
      stack: "Total3",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(58, 149, 255, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(58, 149, 255, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [34, 33, 31, 39, 36, 30, 35]
    },
    {
      name: "通过人数",
      type: "line",
      stack: "Total4",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(255, 140, 15, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(255, 140, 15, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [10, 13, 15, 11, 17, 11, 19]
    }
  ]
};
const ecOptionWhen = {
  color: ["#525fff"],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985"
      }
    }
  },

  grid: {
    left: "0%",
    right: "0%",
    bottom: "0%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: true,

      data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      axisTick: {
        inside: true, //刻度
        lineStyle: {
          color: "#DEEAFF"
        }
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      axisTick: {
        // show: false,
      },
      splitLine: {
        show: false
      }
    }
  ],
  series: [
    {
      name: "候选人",
      type: "line",
      stack: "Total",
      smooth: false,
      lineStyle: {
        width: 1.5,
        cap: "round"
        // shadowBlur: 6,
        // shadowOffsetY: 14,
        // // shadowOffsetX: 8,
        // opacity: 0.8
      },
      itemStyle: {
        //拐点样式
        borderType: "solid",
        borderWidth: 2,
        borderColor: "#ffffff"
      },
      showSymbol: true, //拐点
      symbol: "circle",
      symbolSize: 7,
      areaStyle: {
        opacity: 0,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(82, 95, 255, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(82, 95, 255, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [0, 0, 1, 28, 180, 170, 20],
      animationEasing: "bounceOut",
      animationDuration: 1500
    }
  ]
};
const ecOptionLong = {
  color: ["#525fff"],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985"
      }
    }
  },

  grid: {
    left: "0%",
    right: "0%",
    bottom: "0%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: true,

      data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      axisTick: {
        inside: true, //刻度
        lineStyle: {
          color: "#DEEAFF"
        }
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      axisTick: {
        // show: false,
      },
      splitLine: {
        show: false
      }
    }
  ],
  series: [
    {
      name: "候选人",
      type: "bar",
      stack: "Total",
      smooth: false,
      barWidth: 30, // 柱图宽度
      // barMaxWidth: 30, // 最大宽度
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      itemStyle: {
        normal: {
          //柱形图圆角，初始化效果
          barBorderRadius: [3, 3, 2, 2]
        }
      },

      showSymbol: true, //拐点
      symbol: "circle",
      symbolSize: 7,
      areaStyle: {
        opacity: 0,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(82, 95, 255, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(82, 95, 255, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [0, 0, 1, 28, 180, 170, 20],
      animationEasing: "bounceOut",
      animationDuration: 1500
    }
  ]
};

export { ecOptionLD, ecOptionWhen, ecOptionLong };
